import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { observer } from 'mobx-react';

import CompaniesStore from 'stores/Companies';
import ContentStore from 'stores/Content.store';
import InjectMetaTags from 'common/components/InjectMetaTags/InjectMetaTags';

import CompanyBoxPlaceholder from './placeholder/CompanyBox/CompanyBoxPlaceholder';

import Placeholder from 'common/components/Placeholder/Placeholder';

import messages from './CompaniesView.intl';
//styles
import styles from './CompaniesView.module.scss';

//components
import Company from './components/Company/Company';
import { Container, Title } from 'common/components/Layout/Layout';

@injectIntl
@observer
export default class CompaniesView extends Component {
  render() {
    const { companies } = CompaniesStore;

    return (
      <div className={styles.Companies}>
        {ContentStore.isLoaded && (
          <InjectMetaTags {...ContentStore.content.ourCompaniesSEO} />
        )}
        <Container>
          <Title title={this.props.intl.formatMessage(messages.heading)} />
        </Container>
        <Placeholder
          component={<CompanyBoxPlaceholder />}
          ready={ContentStore.isLoaded}
          repeat={2}
        >
          {companies.map((company, i) => {
            const isEven = i % 2 !== 0;
            const float = isEven ? 'right' : 'left';
            return (
              <div
                key={i}
                className={`${styles.CompanySection}  ${
                  isEven ? styles.CompanySectionBackground : ''
                }`}
              >
                <Container>
                  <Company
                    className={styles.CompanyItem}
                    float={float}
                    company={company}
                    isLoaded={ContentStore.isLoaded}
                  />
                </Container>
              </div>
            );
          })}
        </Placeholder>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Companies/CompaniesView.js